// Constants for Location Content Edition Modal

// Destination options for billet destination selection (matches old system)
export const DESTINATION_OPTIONS = [
  { value: "FALSE", label: "Roanoke" }, // FALSE = isForSale false
  { value: "TRUE", label: "Customer" }, // TRUE = isForSale true
];

// Default billet count for new entries
export const DEFAULT_BILLETS_COUNT = "1";

// Heat number validation
export const HEAT_NUMBER_LENGTH = 6;

// Validation error messages
export const VALIDATION_MESSAGES = {
  SELECT_SECTION_FIRST: "Select a section first",
  SELECT_GRADE_FIRST: "Select a grade first",
  SELECT_POSITION_FIRST: "Select a position first",
  SELECT_QUALITY_FIRST: "Select a quality first",
  SELECT_DESTINATION_FIRST: "Select a destination first",
  INSERT_HEAT_NUMBER_FIRST: "Insert a heat number first",
  INVALID_HEAT_NUMBER_LENGTH:
    "Invalid heat number. The min lenght is 6 characters",
  INSERT_LENGTH_FIRST: "Insert a length first",
  INVALID_LENGTH_FORMAT: "Invalid length. Wrong format. It has to be a number.",
  INVALID_LENGTH_ZERO: "Invalid length. It has to be greather than zero.",
  INSERT_BILLETS_COUNT_FIRST: "Insert a billets count first",
  INVALID_BILLETS_COUNT_FORMAT:
    "Invalid billets count. Wrong format. It has to be a number.",
  INVALID_BILLETS_COUNT_ZERO:
    "Invalid billets count. It has to be greather than zero.",
  SELECT_BILLET_GROUP_FIRST: "Please select a billet group first.",
  SELECTED_GROUP_NOT_FOUND: "Selected billet group not found.",
};

// API operation constants
export const API_CONSTANTS = {
  CHECK_EXISTENCE: false,
  CHECK_VALIDATION: true,
  CHECK_PROC_PARAMS: true,
  CHECK_POSITION_EXISTENCE: true,
  LOG_TRANSACTION: true,
};

// Position calculation constants
export const POSITION_CONSTANTS = {
  FIRST_POSITION: 0,
  ADD_FILLING_TYPE_FIFO: "F",
  ADD_FILLING_TYPE_LIFO: "L",
  REMOVE_FILLING_TYPE_FIFO: "F",
  REMOVE_FILLING_TYPE_LIFO: "L",
};

// Destination mapping for isForSale calculation
export const DESTINATION_MAPPING = {
  CUSTOMER: "Customer",
  ROANOKE: "Roanoke",
};
